import { Styles } from 'shared/types';

export const Content: Styles = {
  fontWeight: 600,
};
